import { ProgramTypeEnum } from '../../../../shared/program-type-enum';
import { SubTabEnum, MainTabEnum } from '../../../../shared/discover-tabs-enum';

export const ProgramTypesMapFromTabs = Object.freeze({
  [MainTabEnum.SPORTS]: {
    [SubTabEnum.DAILY]: [
      ProgramTypeEnum.PICKUP,
      ProgramTypeEnum.PRACTICE,
      ProgramTypeEnum.DROPIN,
      ProgramTypeEnum.CLINIC,
    ],
    [SubTabEnum.LEAGUE]: [ProgramTypeEnum.LEAGUE],
    [SubTabEnum.TOURNAMENT]: [ProgramTypeEnum.TOURNAMENT],
  },
  [MainTabEnum.EVENTS]: {
    [SubTabEnum.LIVE]: [ProgramTypeEnum.EVENT],
    [SubTabEnum.VIRTUAL]: [ProgramTypeEnum.VIRTUAL],
  },
  [MainTabEnum.CLASSES]: {
    [SubTabEnum.DAILY]: [
      ProgramTypeEnum.CLASS,
      ProgramTypeEnum.CLINIC,
      ProgramTypeEnum.SERIES, // update TBD
    ],
    [SubTabEnum.SERIES]: [ProgramTypeEnum.SERIES],
  },
  [MainTabEnum.VOLUNTEER]: {
    [SubTabEnum.VOLUNTEER]: [ProgramTypeEnum.VOLUNTEER_LEAGUE, ProgramTypeEnum.VOLUNTEER_EVENT],
  },
  [MainTabEnum.COURT_RENTALS]: {
    [SubTabEnum.BY_SPORT]: [ProgramTypeEnum.RENTAL],
    [SubTabEnum.BY_VENUE]: [ProgramTypeEnum.RENTAL],
  },
});

const getProgramTypesFromTabs = (mainTab, subTab) => {
  if (!mainTab || !subTab) return [];
  const subToMainMap = ProgramTypesMapFromTabs[mainTab];
  if (!subToMainMap[subTab]) return [];
  return subToMainMap[subTab];
};

export default getProgramTypesFromTabs;
